module.exports = __webpack_public_path__ + "img/actionDots.afec48cc.svg";